import * as React from 'react';
import {
  Card, CardHeader, CardContent, Box, Typography, Paper, IconButton, Menu, MenuItem,
} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import type { GridColumns } from '@material-ui/data-grid';
import {
  DataGrid,
} from '@material-ui/data-grid';
import {
  makeStyles, createStyles,
} from '@material-ui/core/styles';
import globalUseStyles from '../../globalClasses';
import { colors } from '../../theme';
import type IRepairRejectReason from './RepairRejectReasonInterfaces';

const useStyles = makeStyles(() => createStyles({
  textBlue: {
    color: colors.primary,
  },
}));

interface RepairRejectReasonLookupProps {
  data: IRepairRejectReason[] | undefined,
  setEditRejectReasonFormValues: (value: IRepairRejectReason) => void,
  setShowModal: (value: boolean) => void,
  deleteRejectReason: () => void,
}

const RepairRejectReasonLookup: React.FC<RepairRejectReasonLookupProps> = ({
  data, setEditRejectReasonFormValues, setShowModal, deleteRejectReason,
}) => {
  const classes = useStyles();
  const globalStyles = globalUseStyles();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [pageSize, setPageSize] = React.useState(25);

  const handleVertIconClick = (event: React.MouseEvent<HTMLButtonElement>, guidParam: string) => {
    if (!anchorEl) {
      setAnchorEl(event.currentTarget);
      if (data?.filter((rrr) => rrr.id === guidParam)[0]) {
        setEditRejectReasonFormValues(data?.filter((rrr) => rrr.id === guidParam)[0]);
      }
    }
  };

  const tableColumns: GridColumns = [
    {
      field: 'reason',
      headerName: 'Reason',
      flex: 1,
    },
    {
      field: 'station',
      headerName: 'Station',
      flex: 0.5,
    },
    {
      field: 'isBroncaReason',
      headerName: 'Is Bronca',
      flex: 0.5,
    },
    {
      field: 'id',
      headerName: 'Actions',
      flex: 0.50,
      renderCell: ({ value }) => (
        ((typeof (value) === 'string')
          ? (
            <IconButton
              aria-label="more"
              aria-controls="long-menu"
              aria-haspopup="true"
              onClick={(event: React.MouseEvent<HTMLButtonElement>) => handleVertIconClick(event, value)}
            >
              <MoreVertIcon />
            </IconButton>
          )
          : <></>
        )
      ),
    },
  ];

  const tableRows = data && data?.map((rrr, index) => ({
    id: rrr.id || index,
    reason: rrr.reason || '',
    isBroncaReason: rrr.isBroncaReason,
    station: rrr.station?.label || '',
  }));

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleEditRejectReason = () => {
    setShowModal(true);
  };

  return (
    <Paper>
      <Card>
        <CardHeader
          title={(
            <Typography variant="h6" className={classes.textBlue} display="inline">{'Repair Reject Reasons'}</Typography>
              )}
          disableTypography
        />
        <CardContent>
          <Box height={((pageSize + 1) * 52) + 100}>
            <DataGrid
              rows={tableRows || []}
              columns={tableColumns}
              pageSize={pageSize}
              rowsPerPageOptions={[10, 25, 50, 100]}
              loading={!data}
              onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              className={globalStyles.transparentDataGrid}
            />
          </Box>
          {anchorEl
              && (
                <Menu
                  anchorEl={anchorEl}
                  keepMounted
                  open
                  onClose={handleCloseMenu}
                  anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                >
                  <MenuItem id="edit-bin-button" onClick={() => { handleEditRejectReason(); handleCloseMenu(); }}>{'Edit'}</MenuItem>
                  <MenuItem id="delete-bin-button" onClick={() => { deleteRejectReason(); handleCloseMenu(); }}>{'Delete'}</MenuItem>
                </Menu>
              )}
        </CardContent>
      </Card>
    </Paper>
  );
};

export default RepairRejectReasonLookup;
